import { denormalize } from "normalizr";

import { purchasesList } from "../../../api/schema";

export default state => {
  try {
    const items = state.purchases.ids;
    const denormalized = denormalize(
      { items },
      { items: [purchasesList] },
      state.entities
    );
    return denormalized.items;
  } catch (err) {
    return [];
  }
};
